<template>
  <div></div>
</template>

<script>
export default {
  name: "Aggregator"
};
</script>
